import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { ImageUploader, TextArea, Toast } from 'antd-mobile-v5'
import OSS from "ali-oss";
import ManMode from '../../static/images_ae/man_mode.png'; //人体图片（男）
import Header from '../../static/images_ae/human_header.png'; //头部
import Chest from '../../static/images_ae/human_chest.png'; //胸部
import Abdomen from '../../static/images_ae/human_abdomen.png'; //腹部
import Limb from '../../static/images_ae/human_limb.png'; //四肢
import Other from '../../static/images_ae/human_other.png'; //其他部位

import A_Header from '../../static/images_ae/A_human_header.png';
import A_Chest from '../../static/images_ae/A_human_chest.png';
import A_Abdomen from '../../static/images_ae/A_human_abdomen.png';
import A_Limb from '../../static/images_ae/A_human_limb.png';
import A_Other from '../../static/images_ae/A_human_other.png';

import Assistant from '../../static/images_ae/assistant.png'; //其他部位
import AssistantTip from '../../static/images_ae/assistant_tip.png';
import AssistantTip2 from '../../static/images_ae/assistant_tip2.png';
import { ApiCore } from '../../api/index';

const api = new ApiCore();

const AeReport = () => {

    const [currentStep, setCurrentStep] = useState(1)

    const [headerCode, setHeaderCode] = useState('')
    const [chestCode, setChestCode] = useState('')
    const [abdomenCode, setAbdomenCode] = useState('')
    const [limbCode, setLimbCode] = useState('')
    const [otherCode, setOtherCode] = useState('')

    const [activePosition, setActivePosition] = useState('头部')

    const [symptomList, setSymptomList] = useState([]) //所有身体症状list
    const [activeSymptom, setActiveSymptom] = useState([])  //选中的身体症状
    const [drugsList, setDrugsList] = useState([])  //所有药品list
    const [activeDrug, setActiveDrug] = useState('')

    const [content, setContent] = useState('')
    const [ossData, setOssData] = useState({});// 获取OSS访问令牌
    const [fileList, setFileList] = useState([]) //知情同意书文件列表

    useEffect(() => {
        document.title = 'AE评测上报';
        getPosition()
        getOssData()
    }, [])

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    };

    const getPosition = () => {
        api.getDiagnosisPosition().then(res => {
            if (res.code == 0) {
                res.data.forEach(v => {
                    switch (v.name) {
                        case '头部':
                            setHeaderCode(v.code)
                            choosePosition(v.code, '头部')
                            break;
                        case '胸部':
                            setChestCode(v.code)
                            break;
                        case '腹部':
                            setAbdomenCode(v.code)
                            break;
                        case '四肢':
                            setLimbCode(v.code)
                            break;
                        case '其他':
                            setOtherCode(v.code)
                            break;
                        default:
                            break;
                    }
                });
            }
        })
    }

    const choosePosition = (code, name) => {
        api.getDiagnosisSymptom(code).then(res => {
            if (res.code == 0) {
                setActivePosition(name)
                setSymptomList(res.data)
            }
        })
    }


    /**
     * 选择症状
     * @param {*} code 
     */
    const chooseSymptom = (data) => {
        let _activeSymptom = JSON.parse(JSON.stringify(activeSymptom))
        let Index = _activeSymptom.findIndex(v => v.code == data.code)
        if (Index == -1) {
            _activeSymptom.push(data)
        } else {
            _activeSymptom.splice(Index, 1)
        }
        setActiveSymptom(_activeSymptom)
    }

    /**
     * 选择药品
     * @returns 
     */
    const chooseDrug = (code) => {
        setActiveDrug(code)
    }


    const handleNext = () => {
        if (currentStep == 1) {
            if (activeSymptom.length == 0) {
                Toast.show({
                    content: '请选择症状'
                })
                return false
            }
            api.getDiagnosisDrugs().then(res => {
                if (res.code == 0) {
                    setCurrentStep(2)
                    setDrugsList(res.data)
                }
            })
        } else if (currentStep == 2) {
            if (activeDrug == '') {
                Toast.show({
                    content: '请选择药品'
                })
                return false
            }
            setCurrentStep(3)
        }
    }

    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
    const filterPathPre = (json, type) => {
        let newJson = json;
        let data = [];
        data = newJson.pathPre.split(',')
        data.map((i) => {
            if (i.includes(type)) {
                newJson.pathPre = i
            }
        })
        return newJson
    }




    const uploadImage = (file) => {
        return new Promise((resolve, reject) => {
            let client = new OSS({ ...filterPathPre(ossData, 'image') });
            let tenantCode = localStorage.getItem('tenantCode')
            let accountInf = localStorage.getItem('accountInf')
            let accounData = accountInf ? JSON.parse(accountInf) : {}

            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                let time = new Date().getTime();
                const path = `${ossData.pathPre}${tenantCode}/${accounData.account}/${time}${suffix}`;
                // oss上传
                client.put(
                    path,
                    file,
                ).then((res) => {
                    resolve({ url: res.url });
                }).catch((err) => {
                    Toast.show({
                        content: '上传失败请重试'
                    })
                })

            }
        })
    }

    const handleFinish = () => {

        let ossList = fileList.map((obj) => {
            return obj.url;
        });


        let symptom = activeSymptom.map(x => x.name).join(',')
        let params = {
            position: activePosition,
            symptom: symptom,
            medicine: activeDrug,
            content: content,
            oss: ossList,
        }

        api.addAeReport(params).then(res => {
            if (res.code == 0) {
                Toast.show({
                    content: '提交成功'
                })
                // eslint-disable-next-line
                wx.miniProgram.navigateTo({
                    url: `/pages/aeRisk/index?id=${res.data.id}`,
                    success: function (e) {
                    },
                    fail: function (e) {
                    }
                })
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    return (
        <div className={styles.aeContainer} >
            <div className={styles.aeHeader}>{currentStep == 1 ? '选择出现不良反应的部位和相应症状' : currentStep == 2 ? '选择您的用药信息' : '补充信息'}</div>
            {currentStep == 1 && <div className={styles.firstContent}>
                <img className={styles.human_body} src={ManMode} alt="" />
                <img className={styles.human_header} src={activePosition == '头部' ? A_Header : Header} onClick={() => choosePosition(headerCode, '头部')} alt="" />
                <img className={styles.human_chest} src={activePosition == '胸部' ? A_Chest : Chest} onClick={() => choosePosition(chestCode, '胸部')} alt="" />
                <img className={styles.human_abdomen} src={activePosition == '腹部' ? A_Abdomen : Abdomen} onClick={() => choosePosition(abdomenCode, '腹部')} alt="" />
                <img className={styles.human_limb} src={activePosition == '四肢' ? A_Limb : Limb} onClick={() => choosePosition(limbCode, '四肢')} alt="" />
                <img className={styles.human_other} src={activePosition == '其他' ? A_Other : Other} onClick={() => choosePosition(otherCode, '其他')} alt="" />
                <div className={styles.opertion_content}>
                    <div className={styles.options_module}>
                        <div className={styles.tip}>根据选择的部位选择出现的症状，可多选：</div>
                        <div className={styles.options}>
                            {
                                symptomList.map((v, i) => (
                                    <div
                                        className={(activeSymptom.findIndex(item => item.code == v.code)) == -1 ? styles.option : styles.activeOption}
                                        key={i}
                                        onClick={() => chooseSymptom(v)}
                                    >{v.name}</div>
                                ))
                            }
                        </div>
                    </div>

                    <div className={styles.nextBtn} onClick={handleNext}></div>
                </div>
            </div>}

            {currentStep == 2 && <div className={styles.secondContent}>
                <div className={styles.sconde_top}>
                    <img className={styles.assistant} src={Assistant} alt="" />
                    <img className={styles.assistantTip} src={AssistantTip} alt="" />
                </div>
                <div className={styles.options_module}>
                    <div className={styles.tip}>选择药品：</div>
                    <div className={styles.options}>
                        {
                            drugsList.map((v, i) => (
                                <div onClick={() => chooseDrug(v.code)} className={activeDrug == v.code ? styles.activeOption : styles.option} key={i} >{v.name}</div>
                            ))
                        }
                    </div>
                </div>
                <div className={styles.nextBtn} onClick={handleNext}></div>
            </div>}
            {currentStep == 3 && <div className={styles.lastContent}>
                <div className={styles.sconde_top}>
                    <img className={styles.assistant} src={Assistant} alt="" />
                    <img className={styles.assistantTip} src={AssistantTip2} alt="" />
                </div>

                <div className={styles.fillInfo_content}>

                    <div className={styles.fillInfo}>
                        <TextArea
                            rows={4}
                            style={{ '--placeholder-color': '#AD6800', '--font-size': '14px' }}
                            placeholder='在此处输入补充信息……'
                            value={content}
                            onChange={val => {
                                setContent(val)
                            }}
                        />
                    </div>
                    <div className={styles.uploadImg}>
                        <div className={styles.upload}>
                            <div className={styles.uploadImgLabel}>上传相关图片</div>
                            <ImageUploader
                                value={fileList}
                                multiple={true}
                                onChange={setFileList}
                                upload={uploadImage}
                                style={{ '--cell-size': '76px' }}
                            />
                        </div>
                    </div>
                </div>


                <div className={styles.finishBtn} onClick={handleFinish}></div>
            </div>}
        </div>
    )
}

export default AeReport
